import PageShell from '../components/PageShell'
import { STEPS, APP_REGISTER_URL } from '../content/site'

export default function HowItWorksPage() {
  return (
    <PageShell
      title="How It Works"
      intro="From scattered public postings to a focused list of opportunities you can act on — here is the real ProcurAlerts workflow."
    >
      <ol className="space-y-8 mb-12">
        {STEPS.map((step) => (
          <li key={step.num} className="flex gap-5">
            <span className="text-3xl font-bold font-mono text-[#06b6d4]/40 leading-none pt-1 select-none">
              {step.num}
            </span>
            <div>
              <h2 className="text-xl font-semibold text-white leading-[1.3]">{step.title}</h2>
              <p className="mt-2 text-[15px] leading-[1.7] text-[#9ca3af]">{step.desc}</p>
            </div>
          </li>
        ))}
      </ol>

      <section className="mb-12">
        <h2 className="text-xl font-semibold text-white mb-3">Review and track</h2>
        <p className="text-[15px] text-[#9ca3af] leading-[1.7] mb-4">
          Open any matched bid to review the source information ProcurAlerts captured —
          scope, deadlines, contacts, documents, and submission details when available. Add
          the bids that fit to your Watchlist and move them through your pipeline from
          Watching to Preparing to Submitted, and record the outcome.
        </p>
      </section>

      <section className="mb-12">
        <h2 className="text-xl font-semibold text-white mb-3">Prepare your response</h2>
        <p className="text-[15px] text-[#9ca3af] leading-[1.7] mb-4">
          Keep the documents agencies ask for — W-9, insurance certificates, licenses,
          bonding — in the Document Vault with expiry reminders. When you are ready to
          respond, the Bid Package generator assembles your documents and submission
          instructions into a package you can download or send.
        </p>
        <p className="text-[15px] text-[#9ca3af] leading-[1.7]">
          <strong className="text-white">Important:</strong> always confirm requirements,
          deadlines, addenda, and submission instructions against the issuing agency or the
          official procurement source before bidding. ProcurAlerts organizes what sources
          publish; the agency's official notice is authoritative.
        </p>
      </section>

      <a
        href={APP_REGISTER_URL}
        className="inline-block bg-[#06b6d4] text-[#0d1117] text-sm font-semibold px-6 py-3 rounded-lg hover:bg-[#22d3ee] transition-all duration-200"
      >
        Start your 14-day free trial
      </a>
    </PageShell>
  )
}
